import config from "./config/system";
import axios from "@/utils/request";
export const uploadFile = (params) => axios.post(config.uploadFile, params);
export const examPhotoAdd = (params) => axios.post(config.examPhotoAdd, params);
